import { Action, createActionGroup, emptyProps, props } from "@ngrx/store";

import { FullTransactionFragment, InvoiceWithArtifactsFragment } from "../../../generated/graphql.generated";
import { ActionSource } from "../../state/action-sources";

// What the user was actually trying to do when the refresh was triggered, so
// the refreshed document lands in the right place once it is ready.
export type InvoiceRefreshIntent = 'preview' | 'download';

export const JobInvoiceActions = createActionGroup({
  source: ActionSource.JOB_INVOICE,
  events: {
    'Invoice Component Clicked': props<{ invoiceId: string }>(),
    'Send Invoice Button Clicked': props<{ invoiceId: string }>(),
    'Pay Invoice Menu Item Clicked': emptyProps(),
    'Preview Invoice Menu Item Clicked': emptyProps(),
    'Download Invoice Menu Item Clicked': emptyProps(),
    'View Invoice As Employee Menu Item Clicked': emptyProps(),
    'View Invoice As Customer Menu Item Clicked': emptyProps(),
    'Finalize Invoice Menu Item Clicked': emptyProps(),
    'Void Invoice Menu Item Clicked': emptyProps(),
    'Delete Invoice Menu Item Clicked': emptyProps(),
    'Export Invoice to Quickbooks Menu Item Clicked': emptyProps(),
    'Force Update Invoice Menu Item Clicked': emptyProps(),
    'Open Invoice In Right Panel Menu Item Clicked': emptyProps(),
    'Open Invoice Actions Menu Button Clicked': props<{ invoiceId: string }>(),
    'Get Invoice Link Success': props<{
      jobId: string;
      invoiceId: string;
      link: string;
      promptedBy: Action;
    }>(),
    'Finalize Invoice Success': props<{
      jobId: string;
      invoiceId: string;
    }>(),
    'Finalize Invoice Error': props<{
      error: Error;
    }>(),
    'Void Invoice Success': props<{
      jobId: string;
      invoiceId: string;
    }>(),
    'Void Invoice Error': props<{
      error: Error;
    }>(),
    'Delete Invoice Success': props<{
      jobId: string;
      invoiceId: string;
    }>(),
    'Delete Invoice Error': props<{
      error: Error;
    }>(),
    'Create Invoice Button Clicked': props<{
      eventIds: string[];
      jobId: string;
    }>(),
    'Create Invoice Success': props<{
      invoice: InvoiceWithArtifactsFragment;
      eventIds: string[];
      appliedTransactions: FullTransactionFragment[];
    }>(),
    'Create Invoice Error': props<{
      error: Error;
    }>(),
    'Force Update Invoice Success': props<{
      jobId: string;
      invoiceId: string;
    }>(),
    'Force Update Invoice Error': props<{
      error: Error;
    }>(),
    'Export Invoice to Quickbooks Success': props<{
      jobId: string;
      invoiceId: string;
      quickbooksId: string;
    }>(),
    'Export Invoice to Quickbooks Error': props<{
      error: Error;
    }>(),
    'Send Invoice Success': props<{
      jobId: string;
      invoiceId: string;
      updated: boolean;
    }>(),
    'Send Invoice Error': props<{
      invoiceId: string;
      error: Error;
    }>(),
    'Update Invoice Requested': props<{
      invoiceId: string;
      then: InvoiceRefreshIntent;
    }>(),
    'Preview Invoice Requested': emptyProps(),
    'Download Invoice Requested': emptyProps(),
    'Update Invoice Success': props<{
      jobId: string;
      invoiceId: string;
      then: InvoiceRefreshIntent;
    }>(),
    'Update Invoice Error': props<{
      invoiceId: string;
      error: Error;
    }>(),
    'Update Invoice Refused': props<{
      jobId: string;
      invoiceId: string;
      then: InvoiceRefreshIntent;
      reason: string;
    }>(),
  },
});
